import React from 'react';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { ProjectedIncomeChart } from '../../../ProjectedIncomeChart/ProjectedIncomeChart';

interface Props {
  title: string;
}

export const ProjectedIncomeCard = React.memo(({ title }: Props) => {
  return (
    <Card p="16">
      <Text variant="cardTitle" mb="24">
        {title}
      </Text>

      <Box>
        <ProjectedIncomeChart />
      </Box>
    </Card>
  );
});
